import axios from "axios";
import { useState } from "react";
import AllQuestion from "../AllQuestion";
import DocumentLoading from "../../Loading/ExportLoader";
import CreateAssessmentComponent from "../../Modal/CreateAssessmentComponent";
import UploadAssessmentComponent from "../../Modal/UploadAssessment";
import ExportQuestionModal from "../../Modal/ExportQuestionModal";

import { CompetencyQuestion } from "../../../Api/api";
import { useAuth } from "../../../Auth/Auth";

import exportFromJSON from "export-from-json";

export default function CompetencyQuestions(props) {
  const { readCookie, DisplaySnackbar } = useAuth();
  const [questionUploading, setQuestionUploading] = useState(false);

  const handleCreateAssessment = async (field) => {
    const {
      question,
      questionType,
      assertion,
      reasoning,
      options,
      cognitive,
      difficulty,
      correctAnswers,
      quesImg,
      assertImg,
      reasonImg,
      optionsFile,
    } = field;

    let form = new FormData();

    form.append("subjectId", props.subjectId);
    form.append("chapterId", props.chapterId);

    [
      { img: quesImg, name: "questionImg" },
      { img: assertImg, name: "assertImg" },
      { img: reasonImg, name: "reasonImg" },
    ].forEach((data) => {
      form.append(data.name, data.img);
    });

    for (let i = 0; i < optionsFile.length; i++) {
      form.append(`op${i + 1}`, optionsFile[i].value);
    }

    form.append(
      "question",
      JSON.stringify({
        question,
        questionType,
        description: {
          assertion,
          reasoning,
        },
        options,
        cognitive,
        difficulty,
        correctAnswers,
        visibilityStatus: "publicForAll",
      })
    );

    await axios
      .post(CompetencyQuestion.addQuestion, form, {
        headers: { token: `${readCookie("token")}` },
        validateStatus: () => true,
      })
      .then((res) => {
        if (res.data.status !== "success") {
          throw res;
        }
        props.setQuestion([{ ...res.data.data.question }, ...props.questions]);
        props.setModal(false);
        DisplaySnackbar("Question Created", "success");
      })
      .catch((err) => {
        DisplaySnackbar(err.data.message, "error");
      });
  };

  const handleUpdateQuestion = async (id, data, cb) => {
    await axios
      .patch(CompetencyQuestion.editQuestion(id), data, {
        headers: {
          token: `${readCookie("token")}`,
        },
      })
      .then((res) => {
        cb();
        props.setQuestion(
          props.questions.map((que) =>
            que._id === id ? { ...res.data.data.question } : que
          )
        );
        DisplaySnackbar("Question Updated", "success");
      })
      .catch((err) => {
        if (err.reponse) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
  };

  const handleDeleteQuestion = (id) => {
    axios
      .delete(CompetencyQuestion.deleteQuestion(id), {
        headers: {
          token: `${readCookie("token")}`,
        },
      })
      .then((res) => {
        props.setQuestion(props.questions.filter((item) => item._id !== id));
        DisplaySnackbar("Deleted Successfully", "success");
      })
      .catch((err) => {
        if (err.reponse) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
  };

  const handleUploadAssessment = async (quest) => {
    props.setModal(false);
    setQuestionUploading(true);
    await axios
      .post(
        CompetencyQuestion.UploadQuestions,
        {
          subjectId: props.subjectId,
          chapterId: props.chapterId,
          questions: quest,
        },
        {
          headers: {
            token: `${readCookie("token")}`,
          },
        }
      )
      .then((res) => {
        props.setModal(false);
        if (res?.data?.errors?.errorLogs?.length) {
          let data = res?.data?.errors?.errorLogs.map((item) => {
            return {
              row: item?.row,
              error: item?.error,
            };
          });

          const fileName = "Error_Logs";
          const exportType = exportFromJSON.types.csv;
          exportFromJSON({ data, fileName, exportType });
        }
        DisplaySnackbar(
          `Question Inserted = ${res.data?.errors?.inserted} and Question Skipped= ${res?.data?.errors?.skipped} out of Total Question=${res?.data?.errors?.totalQuestions} `,
          "info",
          10000000
        );
      })
      .catch((err) => {
        if (err.response) {
          DisplaySnackbar(err.response.data.message, "error");
        }
      });
    setQuestionUploading(false);
  };

  return (
    <>
      <div style={{ padding: "50px 0", margin: "auto" }}>
        <AllQuestion
          loading={props.loading}
          render={true}
          filterBy={props.filterBy}
          handleUpdateQuestion={handleUpdateQuestion}
          handleDeleteQuestion={handleDeleteQuestion}
          topicQuestion={props.questions}
          setQuestion={props.setQuestions}
          topicId={""}
          assessmentType="competency"
        />
      </div>
      {props.modal ? (
        <>
          {props.headerText === "Create Assessment" ? (
            <CreateAssessmentComponent
              handleCreateAssessment={handleCreateAssessment}
              setModal={props.setModal}
              no={props.questions.length + 1}
              assessmentType="competency"
            />
          ) : (
            <UploadAssessmentComponent
              type="competency"
              handleUploadAssessment={handleUploadAssessment}
              setModal={props.setModal}
            />
          )}
        </>
      ) : null}
      {questionUploading && (
        <DocumentLoading text="Please Wait we are uploading your questions" />
      )}
      {props.exportQuestionModal && (
        <ExportQuestionModal
          type="competency"
          setModal={props.setExportQuestionModal}
          sources={props.sources}
        />
      )}
    </>
  );
}
